import {
  Card,
  CardBody,
  Button,
  Container,
  Col,
  Row,
  CardFooter,
  Stack,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
// import { LOGIN, SETTINGS, LOANDUES } from "../../services/actions";
import { SignOut, Warning } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

import Footer from "../pages/public_payment/Footer";
import React from "react";
import paymentImage from "../pages/public_payment/payhuman.png";
import PwaInstallPrompt from "../components/PwaInstallPrompt";


export default function AppLayout({ children }) {
  let dispatch = useDispatch();
  const navigate = useNavigate();
  const [main, setMain] = React.useState();
  let loanState = useSelector((state) => state?.loanduesState);
  let userState = useSelector((state) => state?.login);
  const [loans, setLoans] = React.useState();
  const [selectedLoans, setSelectedLoans] = React.useState(null);
  let settingsState = useSelector((state) => state?.settingsState);
  // let main = JSON.parse(localStorage.getItem("settings") || '{}')
  const [toggle, setToggle] = React.useState(0);
  const { handleSubmit, control } = useForm({
    defaultValues: { username: "admin@gmail.com", password: "Admin@123" },
    mode: "all",
  });
//   let user = JSON.parse(localStorage.getItem("data") || "{}");
//   React.useEffect(() => {
//     try {
//       dispatch({
//         type: `${LOANDUES}_GET`,
//         payload: user.customerID,
//       });

//       dispatch({ type: `${SETTINGS}_GET`, payload: 1 });
//     } catch (err) {}
//   }, []);
  // /Flipcard
  const handlePayment = (payAmount) => {
    console.log("Payment initiated for amount:", payAmount);
  };

  React.useEffect(() => {
    setLoans(loanState?.data?.data);
    console.log("LONAS:", loanState);
  }, [loanState?.data]);

   React.useEffect(() => {
     let mainStr = settingsState?.data?.data?.main;
     let main = typeof mainStr === "string" ? JSON.parse(mainStr) : mainStr;
     setMain(main);
     localStorage.setItem("settings", JSON.stringify(main));
   }, [settingsState]);

  



  return (
    <>
      <Container
        fluid
        className="g-0 w-100 vh-100 "
        style={{ backgroundColor: "rgba(255, 255, 255, 0.8)" }}
      >
        <Row
          className=" g-0 d-flex "
          style={{ backgroundColor: "rgba(255, 255, 255, 0.8)" }}
        >
          <Col
            xs={12}
            md={6}
            className=" d-flex flex-column "
            style={{
              height: "100vh",
              overflowY: "auto",
              scrollbarWidth: "none", // Firefox
              msOverflowStyle: "none", // IE & Edg
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }}
          >
         {/* Left side content */}

 {children}
          </Col>
          {/* Right Section */}
          <Col
            md={6}
            className=" d-none d-md-flex flex-column  align-items-center justify-content-center"
            // style={{
            //   backgroundColor: "#cad7fe",
            style={{
              position: "fixed",
              right: 0,
              top: 0,
              height: "100vh",
              width: "50vw",

              backgroundColor: "rgba(246, 246, 246, 0.8)",
            }}
          >
            <Container className="d-flex justify-content-end">
              <img
                src={main?.icon}
                style={{
                  marginTop: "20px",
                  height: "50px",
                  width: "250px",
                  objectFit: "contain",
                }}
              />
            </Container>
            <Container
            CL
              style={{
                marginBottom: "100px",
                width: "100%", // Adjust width as needed
                height: "700px", // Adjust height as needed
                overflow: "hidden",
                // position: "relative",
              }}
            >
              <img
                src={paymentImage}
                alt="Decorative"
                className="img-fluid mb-5 "
                style={{
                  marginBottom: "80px",
                  paddingBottom: "20px",
                  width: "100%",
                  height: "auto",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            </Container>
          </Col>
          {/* Right Section */}
        </Row>
        {/* Footer for larger screens */}
       
        <footer
          className=" d-none d-sm-block d-flex box-footer text-center text-center mt-1 w-100  position-fixed  position-md-static "
          style={{
            bottom: 0, // Required for position-fixed
            width: "100%",
            bottom: 0,
            borderTop: "2px solid black",
            // height: 75,
            zIndex: 1000, // Ensure it stays on top
          }}
        >
          
          <div
            className="my-2"
            style={{
              bottom: 0, // Required for position-fixed
              width: "100%",
              // zIndex: 1000, // Ensure it stays on top
            }}
          >
            {/* <img src={icon ? icon : main?.icon}
              style={{
                marginTop:"5px",
                height: "50px", // Adjust height
                width: "250px", // Adjust width
                objectFit: "contain", // Maintain aspect ratio
              }} /> */}

            {/* <img
              src={logo}
              alt="Logo"
              style={{
                marginTop: "5px",
                height: "50px", // Adjust height
                width: "250px", // Adjust width
                objectFit: "contain", // Maintain aspect ratio
              }}
            /> */}
            <div className="d-flex justify-content-center mb-2 ">
              <div className="notes2">@All Rights reserved &nbsp; </div>
              <div className="notes2">
                Powered by{" "}
                <span style={{ textTransform: "italic" }}>icrats</span>
              </div>
            </div>
          </div>
        </footer>
        {/* Footer for larger screens */}
        <div className="d-md-none d-md-none">
          <Footer />
        </div>
      </Container>
    </>
  );
}
